// components/layout/ChatColumn/ChatContextDivider.jsx
import React, { forwardRef } from 'react';
import { Scissors } from 'lucide-react';

/*
 * ==============================
 * ChatContextDivider Component
 * Visualizes the boundary between messages in/out of the bot's context window
 * ==============================
 */
const ChatContextDivider = forwardRef(({ messageCount }, ref) => (
  <div ref={ref} className="relative w-full my-8">
    <div className="flex flex-col items-center gap-2">
      <div className="w-full flex items-center gap-4">
        <div className="h-[1px] flex-1 bg-gradient-to-r from-transparent via-yellow-500/50 to-yellow-500/50" />
        <div className="flex-shrink-0 flex items-center gap-2 px-4 py-2 rounded-full bg-surface/20 backdrop-blur-sm border border-primary/20 shadow-lg">
          <Scissors size={12} className="text-primary/60" />
          <span className="text-xs text-primary/60 font-medium whitespace-nowrap">
            Context Boundary
          </span>
        </div>
        <div className="h-[1px] flex-1 bg-gradient-to-l from-transparent via-yellow-500/50 to-yellow-500/50" />
      </div>
      <div className="text-center text-[11px] text-white/40 max-w-md">
        The Assistant has conversational context up to this point in your chat. You can adjust this threshold using the pruning slider on the right.
      </div>
    </div>
  </div>
));

ChatContextDivider.displayName = 'ChatContextDivider';

export default ChatContextDivider;